import { Component, OnInit } from '@angular/core';
import { Headers, Http, RequestOptions, Response } from '@angular/http';
import { ApiClientService } from '../../../services/api-client.service';
import { ConstantsService } from '../../../services/constants.service';
import { ServiceRequestAction, ServiceRequestService } from '../../../services/service-request.service';
import { ResidentForSelect, ServiceRequest, ServiceRequestComment } from '../../../types/data.types';
import { DirectoryService } from '../../../services/directory.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { environment } from 'environments/environment';
import { AuthTokenService } from '../../../services/auth-token.service';
import { IServiceRequest } from '../../../types/api-response/service-request/service-request';
import { ServiceRequestApiService } from '../../../services/api/service-request-api.service';
import { switchMap } from 'rxjs/operators';
import { IServiceRequestComment } from '../../../types/api-response/service-request/service-request-comment';
import { AlertService } from '../../../services/alert.service';
import { ServiceRequestStatus } from '../../../types/api-response/service-request/service-request-status';
import { IServiceRequestUser } from '../../../types/api-response/service-request/service-request-user';

declare const toastr: any;
declare const swal: any;
declare const moment: any;

@Component({
    selector: 'service-detail-section',
    templateUrl: './service-detail-section.component.html',
    styleUrls: ['./service-detail-section.component.scss']
})

export class ServiceDetailSectionComponent implements OnInit {
    /**
     * Available service request statuses
     */
    status = ServiceRequestStatus;

    /**
     * Service Request Actions
     */
    action = ServiceRequestAction;

    title = 'Resident';
    disabledFileInput = false;
    data: ServiceRequest;
    requestTypes: Array<any> = [];
    attachments: Array<any> = [];
    navPosition = 'info';
    commentsNav = 'all';

    commentObj: IServiceRequestComment;

    requestPriorities: Array<any> = [
        {name: 'urgent', displayName: 'Urgent'},
        {name: 'high', displayName: 'High'},
        {name: 'medium', displayName: 'Medium'},
        {name: 'low', displayName: 'Low'}];
    suites = [];
    residents = [];
    buildingSelectIsDisabled = false;
    isRequestInProgress = false;

    constructor(
        public api: ApiClientService,
        public serviceRequestService: ServiceRequestService,
        public directoryService: DirectoryService,
        private http: Http,
        public authenticationService: AuthenticationService,
        public authTokenService: AuthTokenService,
        private serviceRequestApi: ServiceRequestApiService,
        private alertService: AlertService
    ) {}

    ngOnInit() {
        this.resetComment();
        this.getRequestTypes();
    }

    onSubmit(data: any): void {
        if (data.serviceRequestTypeOther && !data.serviceRequestTypeOther.trim().length) {
            toastr.warning('Request Type should not be blank.');
            return;
        }
        const url = `/v1/service_request/${this.serviceRequestService.selectedItemData.id}.json`;
        this.serviceRequestService.api.patch('domainServiceRequest', url, data).subscribe(
            () => this.updateView('The Field was successfully updated', false),
            (error) => this.api.errorHandler(error, 'Update failed!'),
            () => this.serviceRequestService.getData()
        );
    }

    updateView(msg: string, close = true): void {
        if (msg) toastr.success(msg);
        this.serviceRequestService.toggleDetailedView(this.serviceRequestService.selectedItemData, true);
        this.serviceRequestService.getData();
        if (close) this.serviceRequestService.toggleDetailedView(null, false);
    }

    isNotObject(item) {
        return typeof item != 'object';
    }

    changeServiceRequestReadStatus(event, isRead, request) {
        this.serviceRequestService.isReadStatusForChange = isRead;
        this.serviceRequestService.serviceRequestInServiceRequestModal = request;
        this.serviceRequestService.showAddCommentModal = true;
        event.stopPropagation();
    }

    changeServiceRequestStatus(event, status, request) {
        if (!status) return;
        this.serviceRequestService.statusForChange = status;
        this.serviceRequestService.serviceRequestInServiceRequestModal = request;
        this.serviceRequestService.showAddCommentModal = true;
        event.stopPropagation();
    }

    assignServiceRequestTo(request, event) {
        this.serviceRequestService.statusForChange = ServiceRequestStatus.inProgress;
        this.serviceRequestService.showAssignToModal = true;
        this.serviceRequestService.serviceRequestInServiceRequestModal = request;
        event.stopPropagation();
    }

    addFile(e) {
        const file = e.target.files[0];
        const fd   = new FormData();
        e.target.value = null;

        if (['.gif', 'jpeg', '.png', '.jpg', '.bmp', '.pcx', 'tiff'].indexOf(file.name.toLowerCase().slice(-4)) === -1) {
            toastr.warning('You can only upload images in .gif, .jpeg, .png, .jpg, .bmp, .pcx, .tiff formats');
            return;
        }

        if (file.size > 10000000) {
            toastr.warning('Maximum attachment size is 10MB.');
            return;
        }
        if (this.serviceRequestService.selectedItemData.attachments.length >= 20 ) {
            toastr.warning('You can upload only up to 20 images.');
            return;
        }

        fd.append('fileUpload', file);
        fd.append('_format', 'json');

        const token = this.authTokenService.accessToken;
        const headers = new Headers({'Authorization': `Bearer ${token}`});
        const options = new RequestOptions({headers: headers});

        this.serviceRequestService.detailsViewSpinnerShow = true;
        this.disabledFileInput = true;
        this.http.post(`${environment.domainServiceRequest}/_uploader/attachments/upload`, fd, options)
            .map((response: Response) => response.json()).subscribe(
            res => {
                if (!res.path) { toastr.warning('Attachment path should not be blank.'); return; }
                const attachment = {name: file.name, path: res.path};
                this.serviceRequestService.selectedItemData.attachments.push(attachment);
                this.onSubmit({attachments: this.serviceRequestService.selectedItemData.attachments});
            },
            error => this.api.errorHandler(error, 'Upload file failed'),
            () => {
                this.serviceRequestService.detailsViewSpinnerShow    = false;
                this.disabledFileInput = false;
            }
        );
    }

    removeFile(i: number, row) {
        swal(
            ConstantsService.getSwalConfig('Delete Attachment'),
            () => {
                this.serviceRequestService.selectedItemData.attachments.splice(row * 3 + i, 1);
                this.onSubmit({attachments: this.serviceRequestService.selectedItemData.attachments});
                this.serviceRequestService.selectedItemData.attachmentsToDisplay[row].splice(i % 3, 1);
            }
        );
    }

    getRequestTypes() {
        this.requestTypes = [];
        const url = `/v1/service_request_type.json`;
        this.api.get('domainServiceRequest', url).subscribe(
            res => {
                const types = JSON.parse(res._body).entities || [];
                this.requestTypes = types.map(type => ({id: type.id, name: type.name}));
                this.requestTypes.push({id: 0, name: 'Other'});
            },
            error => this.api.errorHandler(error, 'Failed get types')
        );
    }

    submitRequestType(value) {
        if (value.length == 1 && value != '0') {
            this.onSubmit({serviceRequestType: value});
        } else { // if (value == '0') {
            this.onSubmit({serviceRequestTypeOther: value});
        }
    }

    // setEditModeFor(item, fieldName: string, state: boolean) {
    //     this.setEditModeForAll(false);
    //     item.formFields[fieldName].editMode = state;
    // }

    setEditModeForAll(state: boolean) {
        for (const field in this.serviceRequestService.selectedItemData.formFields) this.serviceRequestService.selectedItemData.formFields[field].editMode = state;
    }

    applyChanges(item, form, changedValue, formField) {
        let valueToSend = changedValue;
        if (changedValue.shareContact === 'true')
            valueToSend.shareContact = 1;
        else if (changedValue.shareContact === 'false')
            valueToSend.shareContact = 0;

        if (form.dirty) {
            item[formField] = form.value[formField];
            if(formField == 'building' || formField == 'unit' || formField == 'resident') {
                if(!form.value.building ||
                    !(form.value.unit || (form.value.unit === 0 && form.value.otherSuite)) ||
                    !(form.value.resident || (form.value.resident === 0 && form.value.otherResident))) {
                    toastr.warning('All details about building, unit and resident must be filled to proceed.');
                    return;
                }
                const building = this.serviceRequestService.buildings.find((item) => +item.id === +form.value.building);
                const suite    = this.suites.find((item) => +item.id === +form.value.unit);
                const resident = this.residents.find((item) => +item.id === +form.value.resident);
                valueToSend = {
                    building: {
                        bdId: form.value.building,
                        name: building ? building.name : null,
                        address: building ? building.address : null,
                        corporationNumberBd: building ? building.corporationNumber : null,
                        timezone: building ? (building.timeZone ? building.timeZone.value : null) : null
                    },
                    suite: {
                        bdId:        suite.id ? form.value.unit : 0,
                        suiteNumber: suite.id ? suite.name         : form.value.otherSuite,
                    },
                    resident: {
                        bdId:     resident.id ? resident.id       : 0,
                        fullName: resident.id ? resident.fullName : form.value.otherResident,
                        //Fixme: add resident email
                    },
                };
            }
            if (form.valid) this.setEditModeForAll(false);
            this.onSubmit(valueToSend);
        } else {
            this.setEditModeForAll(false);
        }
    }

    getTypeById(id): string {
        const type = this.serviceRequestService.requestTypesForDetailedView.find((r) => r.id == id);
        return type ? type.name : '';
    }

    activityIsPrivateComment(activity) {
        return activity.data.find(a => a.key == 'Is Private' && a.value == 'yes') ? 1 : 0;
    }

    getCommentsList(filter = 'all'): IServiceRequestComment[] {
        let comments: ServiceRequestComment[] = [];

        if(this.serviceRequestService.selectedItemData.comments) {
            if(filter == 'public') {
                comments =  this.serviceRequestService.selectedItemData.comments.filter(c => !c.isPrivate && c.comment);
            } else if(filter == 'internal') {
                comments = this.serviceRequestService.selectedItemData.comments.filter(c => c.isPrivate && c.comment);
            } else {
                comments = this.serviceRequestService.selectedItemData.comments.filter(c => c.comment);
            }
        }
        comments.sort((a: any, b: any) => {
            if (new Date(a.createdAt) < new Date(b.createdAt)) {
                return 1;
            } else if (new Date(a.createdAt) > new Date(b.createdAt)) {
                return -1;
            } else {
                return 0;
            }
        });
        return comments;
    }

    getCommentTime(comment) {
        return moment(comment.createdAt).fromNow();
    }

    addComment(newStatus: ServiceRequestStatus = null) {
        this.commentObj.comment = String(this.commentObj.comment).trim();

        if(!this.commentObj.comment && !newStatus) {
            toastr.warning('Comment must not be empty');

            return;
        }

        const serviceRequest: Partial<IServiceRequest> = {
            emailNotice: true,
            isReadComment: this.commentObj.comment,
            status: newStatus || this.serviceRequestService.selectedItemData.status
        };

        this.commentObj.serviceRequest = this.serviceRequestService.selectedItemData.id;
        this.commentObj.isNotify = !newStatus;

        const successMessage = this.commentObj.comment ? 'Comment was added successfully' : 'Service Request status updated successfully';
        this.isRequestInProgress = true;
        this.serviceRequestApi.updateServiceRequest(this.serviceRequestService.selectedItemData.id, serviceRequest).pipe(
            switchMap(() => {
                if(newStatus) {
                    this.serviceRequestService.selectedItemData.status = newStatus;
                }

                return this.serviceRequestApi.addComment(this.commentObj);
            })
        ).subscribe(newComment => {
                newComment.user = {
                    fullName: this.authenticationService.user.fullName,
                    email: this.authenticationService.user.email
                };
                this.serviceRequestService.selectedItemData.comments.push(newComment);

                this.resetComment();
                this.isRequestInProgress = false;
                this.alertService.toast.success(successMessage);
            },
            error => {
                this.api.errorHandler(error, 'Failed to add comment');
                this.isRequestInProgress = false;
            }
        );
    }

    setEditModeFor(item, fieldName: string, state: boolean, form?) {
        this.setEditModeForAll(false);
        if(fieldName != 'building' && fieldName != 'unit' && fieldName != 'resident')
            item.formFields[fieldName].editMode = state;
        else {
            if(state) {
                this.getSuites(this.serviceRequestService.selectedItemData.buildingId, this.serviceRequestService.selectedItemData.suiteId, form);
                if(this.serviceRequestService.selectedItemData.suiteId === 0)
                    this.residents.push(new ResidentForSelect(0, 'Other'));
            }
            item.formFields['building'].editMode = state;
            item.formFields['unit'].editMode = state;
            item.formFields['resident'].editMode = state;
        }
    }

    changeBuilding(buildingId: string, form) {
        form.controls['unit'].reset();
        form.controls['resident'].reset();
        this.getSuites(+buildingId, null, form);
    }

    getSuites(buildingId: number, suiteId?: number, form?): void {
        if (!buildingId) return;
        const url = `/v1/suite/select.json?per-page=1000&order-by=suiteNumber|asc&building_id=${buildingId}`;
        this.buildingSelectIsDisabled = true;
        this.api.get('domainBD', url).subscribe(
            res => {
                this.suites = [];
                const suites = JSON.parse(res._body).entities || [];
                this.suites = suites.map(suite => ({id: suite.id, name: suite.suiteNumber}));
                this.suites.push({id: 0, name: 'Other'});
                if (suiteId) this.getResidents(suiteId, form);
                this.buildingSelectIsDisabled = false;
            },
            error => {
                this.buildingSelectIsDisabled = false;
                this.api.errorHandler(error, 'Failed get suites');
            }
        );
    }

    changeUnit(suiteId: string, form) {
        if(form.controls['resident'].value !== 0)
            form.controls['resident'].reset();
        this.getResidents(+suiteId, form);
        if (suiteId + '' === '0') {
            form.controls['resident'].setValue(0);
            setTimeout(() => {
                form.controls['otherSuite'].reset();
                form.controls['otherResident'].reset();
                this.residents.push(new ResidentForSelect(0, 'Other'));
            }, 0);
        }
    }

    suiteToSearchSelect(arr: Array<any>) {
        return arr.map(suite => ({value: suite.id, optionText: suite.name}));
    }

    getResidents(suiteId: number, form): void {
        if (!suiteId) return;
        const url = `/v1/residents/select.json?per-page=1000&suite_id=${suiteId}`;
        this.api.get('domainBD', url).subscribe(
            res => {
                this.residents = [];
                if(form.value.unit !== 0) {
                    const residents = JSON.parse(res._body).entities;
                    this.residents = residents.map(item =>
                        (new ResidentForSelect(item.id, item.fullName, [], item.email))
                    );
                }
                this.residents.push(new ResidentForSelect(0, 'Other'));
            },
            error => this.api.errorHandler(error, 'Failed get Residents')
        );
    }

    changeResident(residentId: number) {
        if (!+residentId)
            this.serviceRequestService.selectedItemData.residentFullName = '';
    }

    actionButtonIsNotAvailable() {
        return !(this.serviceRequestService.selectedItemData.isCanEdit && !this.authenticationService.userIsResident);
    }

    /**
     * Reset comment object
     * to default state
     */
    private resetComment() {
        const user: IServiceRequestUser = {
            bdId: this.authenticationService.user.id,
            fullName: this.authenticationService.user.fullName,
            email: this.authenticationService.user.email
        };

        this.commentObj = new ServiceRequestComment(user, !this.authenticationService.userIsResident);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/service-request/service-detail-section/service-detail-section.component.ts